<script>
  import axios from "axios"
  import { loadJs } from "../../../../../../Script/loadLibrary"
  import notify from "../../../../../../Script/notify"
  import { queryStringToJSON } from "../../../../../../Script/queryString"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import { validateFile } from "../../../../../Publish/BulkUpload/Script/bulkUpload"
  import fileTemplateState from "../../../stores/fileTemplateJsonData"
  import { loadImage } from "../../Script/loadImg"
  import { push, querystring } from "svelte-spa-router"

  export let chooseCertificate
  /**
   * @description Function for Fetching the Image details
   */

  let files
  /**
   * @type {Blob}  blobUrl for the BaseImage
   */
  let blobURL = ""
  /**
   * @type {Number}  baseImage Width
   */
  let width
  /**
   * @type {Number}  baseImage Height
   */
  let height

  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }
  let showLoader = false

  const uploadImage = async (e) => {
    //generating blob url

    try {
      if (!e.target.files.length) return
      files = e.target.files
      await validateFile(files[0])
      // Create object URL for the selected file

      // Assigning file size
      const MAX_FILE_SIZE = 2 * 1024 * 1024

      if (MAX_FILE_SIZE < files[0].size) {
        throw "Maximum size Exceeded"
      }
      $fileTemplateState.baseImageInfo.size = files[0].size

      // Load image and get its natural dimensions
      let img = await loadImage(URL.createObjectURL(files[0]))
      height = img.naturalHeight
      width = img.naturalWidth
      // Check image resolution
      if (width < 900 || height < 900) {
        $fileTemplateState.baseImageInfo.size = 0
        throw "Minimum Resolution Should be 900px"
      }
      if ((width >= 900 && width <= 1200) || (height >= 900 && height <= 1200)) {
        closeNotification.close()
        closeNotification = notify.warning("Better resolution of the image should be 1200px")
      }

      blobURL = URL.createObjectURL(files[0])

      // console.log(blobURL, "72")

      // Set focus on the name input field
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: File template editor\nEVENT: While uploading new base document"
      closeNotification = notify.danger(error, info)
      files = ""
      blobURL = ""
      e.dataTransfer ? (e.dataTransfer.value = null) : (e.target.value = null)
    }
  }

  /**
   * @description Function for display the new base Image
   */
  const changeBaseImage = async () => {
    try {
      // Show loading indicator
      showLoader = true
      // Load the extract colors script if not already loaded
      await loadJs("extractor", "assets/lib/extract-colors.min.js")
      let clrs = await extractColors(blobURL)
      let palette = []

      // Limit the palette to the first 6 colors
      for (let i = 0; i < clrs.length; i++) {
        if (i < 6) {
          palette.push(clrs[i].hex)
        }
      }

      $fileTemplateState.baseImageInfo.uri = blobURL
      $fileTemplateState.baseImageInfo.palette = palette

      let canvasElement = document.querySelector("#fileTempCanvas")
      canvasElement.width = $fileTemplateState.baseImageInfo.width = width
      canvasElement.height = $fileTemplateState.baseImageInfo.height = height

      $fileTemplateState.canvasScale = $fileTemplateState.baseImageInfo.width / canvasElement.clientWidth
      $fileTemplateState.canvasHeight = canvasElement.clientHeight
      $fileTemplateState.activeFontSize = Math.floor($fileTemplateState.canvasHeight * (10 / 100))

      // $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
      //   // let ctx = canvasElement.getContext("2d")
      //   // let width = ctx.measureText(opp.value)
      // console.log(width, "width")
      //   opp.errorX = opp.x < $fileTemplateState.baseImageInfo.width || opp.x < 0
      //   opp.errorY = opp.y > $fileTemplateState.baseImageInfo.height || opp.y > 0
      // console.log(opp.y, $fileTemplateState.baseImageInfo.height, opp.errorY, "y")
      //   return opp
      // })
      $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
        if (opp.type == "text") {
          opp.errorX = opp.x < 0 || opp.x > $fileTemplateState.baseImageInfo.width
          opp.errorY = opp.y < 0 || opp.y > $fileTemplateState.baseImageInfo.height
        } else {
          opp.errorX = opp.x < 0 || opp.x + opp.width > $fileTemplateState.baseImageInfo.width
          opp.errorY = opp.y < 0 || opp.y + opp.height > $fileTemplateState.baseImageInfo.height
        }
        return opp
      })
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: File template editor\nEVENT: While updating new base document"
      closeNotification = notify.danger(error, info)
      // Display error notification and navigate to the templates file page
    } finally {
      showLoader = false
      chooseCertificate = false
    }
  }
</script>

<div class="fixed inset-0 z-20 flex flex-col items-center justify-center overflow-y-auto bg-[#000000cc] backdrop-blur-md transition-opacity">
  <div>
    <div class="w-[400px] rounded-t-md bg-darkgray p-6">
      <div class="flex items-center justify-between pb-3">
        <h1 class="text-lg font-bold tracking-wide text-slate-100">Change Image File</h1>
      </div>

      <div class="flex gap-3">
        <!-- <div class="w-full space-y-2 overflow-y-auto rounded-md border border-stone-700 bg-[#242424] p-3"> -->
        {#if blobURL}
          <div class="flex gap-3">
            <div class="group relative flex w-1/2 items-center justify-center">
              <div class="absolute inset-0 hidden items-center justify-center gap-3 rounded-md bg-[#000000cc] group-hover:flex">
                <button
                  on:click={() => {
                    blobURL = ""
                  }}
                  class="flex cursor-pointer select-none items-center justify-center rounded-full border border-transparent text-xl font-medium text-gray-300 hover:text-red-600 focus:outline-none active:text-red-900"
                >
                  <i class="fa-solid fa-circle-xmark" />
                </button>
              </div>
              <img src={blobURL} alt="uploaded_image" class="aspect-auto max-h-[116px] max-w-full rounded-md" id="img" />
            </div>
            <div class="space-y-3 font-light text-[#A7A7A7]">
              <p class="w-44 truncate font-semibold">{files[0].name}</p>
              <p>{Math.round(files[0].size / 1024)} KB</p>
              <p>{width ? width : 0} x {height ? height : 0}</p>
            </div>
          </div>
        {:else}
          <div class="relative flex cursor-pointer flex-col items-center gap-2 rounded-md border-dashed bg-blue-500 p-5 text-white hover:bg-blue-600">
            <input on:input={uploadImage} type="file" class="absolute inset-0 cursor-pointer opacity-0" accept="image/*" />
            <span class="py-1">
              <i class="fa-solid fa-cloud-arrow-up fa-xl" />
            </span>
            <p class="text-center text-base font-light">Select a file by dragging and dropping it, or Click here to upload.</p>
            <p class="text-sm font-light">Maximum Size 2MB</p>
            <p class="text-sm font-light">Minimum screen dimensions: 900px x 900px.</p>
            <p class="text-sm font-light">Supported formats: jpg, jpeg, png.</p>
          </div>
        {/if}
        <!-- </div> -->
      </div>
    </div>

    <div class="flex justify-between rounded-b-md bg-[#242424] px-5 py-3">
      <button on:click class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none">
        <span class="text-white">
          <i class="fa-solid fa-circle-xmark" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Close</span>
      </button>

      <button disabled={!files} on:click={changeBaseImage} class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30">
        <span class="text-white">
          <i class="fa-solid fa-forward" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Proceed</span>
      </button>
    </div>
  </div>
</div>

{#if showLoader}
  <div class="fixed inset-0 z-30 flex items-center justify-center backdrop-blur-md">
    <div class="h-20 w-20 animate-spin rounded-full border-[3px] border-slate-300 border-r-blue-500" />
  </div>
{/if}
